import { render, staticRenderFns } from "./IbanNumber.vue?vue&type=template&id=494a7b16&"
import script from "./IbanNumber.vue?vue&type=script&lang=js&"
export * from "./IbanNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports